import { Component, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { Cliente } from '../model/cliente.model';
import { Contrato } from '../model/contrato.model';
import { VerificarPermissoes } from '../model/verificarPermissoes.model';
import { ClientesService } from '../service/clientes.service';
import { ContratosService } from '../service/contratos.service';
import { DialogContratoComponent } from './dialog-contrato/dialog-contrato.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { BuscaService } from '../service/busca.service';

@Component({
  selector: 'app-contratos',
  templateUrl: './contratos.component.html',
  styleUrls: ['./contratos.component.css']
})
export class ContratosComponent implements OnInit {

  constructor(private service: ContratosService, private serviceCliente: ClientesService, private router: Router, private buscaService: BuscaService, public dialog: MatDialog) { }

  page = 1;
  pageSize = 1;
  load = true;
  value = 50;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  clientes!: Cliente[];
  clienteId!: string;
  contratos: Array<any> = [];
  validaResp: boolean = false;
  public ordenacaoData: number = 0;
  public dataSource: MatTableDataSource<any> = new MatTableDataSource();
  public columnsToDisplay = [
    'fk_produto',
    'ts_data_vencimento',
    'ts_renovado_em',
    'ts_cancelado_em',
    'acaoEditar', 
    'acaoRenovar', 
    'acaoCancelar'
  ];

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  ngOnInit(): void {
    this.listarCliente();
    this.dataSourcePesquisa();
  }

  listarContratoPaginate(){
    this.load = true;
    this.service.getAll(this.clienteId).subscribe(
      (resp: any) => {
        this.load = false
        this.dataSource.data = resp;
        this.dataSource.paginator = this.paginator;
      },error => {
        if(error == "401"){
          localStorage.removeItem('token')
          this.router.navigate(['/'])
        }
      }
    )
  }

  parametroSolicitacao(page: number): any {
    let params: any = {};
    if (page) {
      params[`page`] = page;
    }
    return params;
  }

  public verificarPermissao(permissoesFuncionalidades: string[]): boolean{
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }

  listarCliente(){
    this.serviceCliente.listarServiceClientes().subscribe(resp => {
      this.clientes = resp
      this.clienteId = localStorage.getItem('cliente')!;
      this.listarContratoPaginate()
    },
    error => {
      if(error == "401"){
        localStorage.removeItem('token')
        this.router.navigate(['/'])
      }
    })
  }

  Opendialog(tipo:any, contratoId:any){
    const dialogRef = this.dialog.open(DialogContratoComponent, {
      width: '30vw',
      data: {'tipo': tipo, 'contratoId': contratoId}
    });
    dialogRef.afterClosed().subscribe(result => {
      this.listarContratoPaginate()
    });
  }

  dataSourcePesquisa(): void {
    this.dataSource.filterPredicate = (data: Contrato, filter: string) => {
      let produto = data.produtos && data.produtos.vc_nome ? this.buscaService.removerAcentos(data.produtos.vc_nome).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
      return produto;
    }
  }

  pesquisarContrato(event: Event): void {
    const pesquisa = (event.target as HTMLInputElement).value;
    this.dataSource.filter = pesquisa;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  public ordenarData(ordenacaoData: number): void {
    this.ordenacaoData = ordenacaoData;
    this.load = true;
    if (ordenacaoData == 1) {
      this.dataSource.data = this.dataSource.data.sort((a: any, b: any) => {
        const dateA = new Date(a.ts_data_vencimento);
        const dateB = new Date(b.ts_data_vencimento);
        this.load = false;
        return dateA.getTime() - dateB.getTime();
        });
    } else {
       this.dataSource.data = this.dataSource.data.sort((a: any, b: any) => {
        const idA = a.sr_id;
        const idB = b.sr_id;
        this.load = false;
        return idA - idB;
        });
    }
  }

  verificarPermissaoRenovar(contrato: any): boolean {
    return this.verificarPermissao(['edita_contrato']) && contrato?.ts_renovado_em == null && contrato?.ts_cancelado_em == null;
  }
}
